<ng-container *ngIf="screenSize === 'desktop'; else mobileTemplate">
  <app-general-desktop></app-general-desktop>
</ng-container>

<ng-template #mobileTemplate>
  <app-general-mobile></app-general-mobile>
</ng-template>
